import React from 'react';
import { getTransferLabel } from '../labelGetters';

export default function TransferDisplay({ transfer, labels, isNew = false }) {
  const transferLabel = getTransferLabel(transfer.id, labels);
  const transferType = transfer.transferType || transferLabel?.transferType;
  const displayName =
    transferLabel?.accommodationName || `Transfer #${transfer.id}`;

  const borderClass = isNew ? 'border-green-300' : 'border-gray-200';

  const getTransferIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'air':
        return 'fa-plane';
      case 'rail':
        return 'fa-train';
      case 'boat':
        return 'fa-ship';
      default:
        return 'fa-car';
    }
  };

  return (
    <div
      className={`flex items-center gap-2 p-2 bg-gray-50 rounded border ${borderClass}`}
    >
      <i
        className={`fa-regular ${getTransferIcon(transferType)} text-purple-500`}
      />
      <div className="flex-1">
        <span className="text-sm text-gray-700">{displayName}</span>
        {transferType && (
          <span className="ml-2 text-xs text-gray-500 capitalize">
            ({transferType.toLowerCase()})
          </span>
        )}
      </div>
    </div>
  );
}
